export enum WindowEvent {
    WINDOW_RESIZE_DEBOUNCED = 'window:resize:debounced',
    WINDOW_RESIZE = 'window:resize',
}
